/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrudSystemActionSubject } from './CrudSystemActionSubject';
import {
    CrudSystemActionSubjectFromJSON,
    CrudSystemActionSubjectFromJSONTyped,
    CrudSystemActionSubjectToJSON,
    CrudSystemActionSubjectToJSONTyped,
} from './CrudSystemActionSubject';
import type { CrudSystemActionType } from './CrudSystemActionType';
import {
    CrudSystemActionTypeFromJSON,
    CrudSystemActionTypeFromJSONTyped,
    CrudSystemActionTypeToJSON,
    CrudSystemActionTypeToJSONTyped,
} from './CrudSystemActionType';
import type { PresetSystemActionType } from './PresetSystemActionType';
import {
    PresetSystemActionTypeFromJSON,
    PresetSystemActionTypeFromJSONTyped,
    PresetSystemActionTypeToJSON,
    PresetSystemActionTypeToJSONTyped,
} from './PresetSystemActionType';
import type { PresetSystemActionSubject } from './PresetSystemActionSubject';
import {
    PresetSystemActionSubjectFromJSON,
    PresetSystemActionSubjectFromJSONTyped,
    PresetSystemActionSubjectToJSON,
    PresetSystemActionSubjectToJSONTyped,
} from './PresetSystemActionSubject';
import type { ExecutionSystemActionSubject } from './ExecutionSystemActionSubject';
import {
    ExecutionSystemActionSubjectFromJSON,
    ExecutionSystemActionSubjectFromJSONTyped,
    ExecutionSystemActionSubjectToJSON,
    ExecutionSystemActionSubjectToJSONTyped,
} from './ExecutionSystemActionSubject';
import type { ExecutionSystemActionType } from './ExecutionSystemActionType';
import {
    ExecutionSystemActionTypeFromJSON,
    ExecutionSystemActionTypeFromJSONTyped,
    ExecutionSystemActionTypeToJSON,
    ExecutionSystemActionTypeToJSONTyped,
} from './ExecutionSystemActionType';

/**
 * 
 * @export
 * @interface SystemActionPoliciesSubjectEnumWrapper
 */
export interface SystemActionPoliciesSubjectEnumWrapper {
    /**
     * 
     * @type {CrudSystemActionSubject}
     * @memberof SystemActionPoliciesSubjectEnumWrapper
     */
    crudSystemActionSubject: CrudSystemActionSubject;
    /**
     * 
     * @type {ExecutionSystemActionSubject}
     * @memberof SystemActionPoliciesSubjectEnumWrapper
     */
    executionSystemActionSubject: ExecutionSystemActionSubject;
    /**
     * 
     * @type {PresetSystemActionSubject}
     * @memberof SystemActionPoliciesSubjectEnumWrapper
     */
    presetSystemActionSubject: PresetSystemActionSubject;
    /**
     * 
     * @type {ExecutionSystemActionType}
     * @memberof SystemActionPoliciesSubjectEnumWrapper
     */
    executionSystemActionType: ExecutionSystemActionType;
    /**
     * 
     * @type {CrudSystemActionType}
     * @memberof SystemActionPoliciesSubjectEnumWrapper
     */
    crudSystemActionType: CrudSystemActionType;
    /**
     * 
     * @type {PresetSystemActionType}
     * @memberof SystemActionPoliciesSubjectEnumWrapper
     */
    presetSystemActionType: PresetSystemActionType;
}



/**
 * Check if a given object implements the SystemActionPoliciesSubjectEnumWrapper interface.
 */
export function instanceOfSystemActionPoliciesSubjectEnumWrapper(value: object): value is SystemActionPoliciesSubjectEnumWrapper {
    if (!('crudSystemActionSubject' in value) || value['crudSystemActionSubject'] === undefined) return false;
    if (!('executionSystemActionSubject' in value) || value['executionSystemActionSubject'] === undefined) return false;
    if (!('presetSystemActionSubject' in value) || value['presetSystemActionSubject'] === undefined) return false;
    if (!('executionSystemActionType' in value) || value['executionSystemActionType'] === undefined) return false;
    if (!('crudSystemActionType' in value) || value['crudSystemActionType'] === undefined) return false;
    if (!('presetSystemActionType' in value) || value['presetSystemActionType'] === undefined) return false;
    return true;
}

export function SystemActionPoliciesSubjectEnumWrapperFromJSON(json: any): SystemActionPoliciesSubjectEnumWrapper {
    return SystemActionPoliciesSubjectEnumWrapperFromJSONTyped(json, false);
}

export function SystemActionPoliciesSubjectEnumWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemActionPoliciesSubjectEnumWrapper {
    if (json == null) {
        return json;
    }
    return {
        
        'crudSystemActionSubject': CrudSystemActionSubjectFromJSON(json['CrudSystemActionSubject']),
        'executionSystemActionSubject': ExecutionSystemActionSubjectFromJSON(json['ExecutionSystemActionSubject']),
        'presetSystemActionSubject': PresetSystemActionSubjectFromJSON(json['PresetSystemActionSubject']),
        'executionSystemActionType': ExecutionSystemActionTypeFromJSON(json['ExecutionSystemActionType']),
        'crudSystemActionType': CrudSystemActionTypeFromJSON(json['CrudSystemActionType']),
        'presetSystemActionType': PresetSystemActionTypeFromJSON(json['PresetSystemActionType']),
    };
}

export function SystemActionPoliciesSubjectEnumWrapperToJSON(json: any): SystemActionPoliciesSubjectEnumWrapper {
    return SystemActionPoliciesSubjectEnumWrapperToJSONTyped(json, false);
}

export function SystemActionPoliciesSubjectEnumWrapperToJSONTyped(value?: SystemActionPoliciesSubjectEnumWrapper | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'CrudSystemActionSubject': CrudSystemActionSubjectToJSON(value['crudSystemActionSubject']),
        'ExecutionSystemActionSubject': ExecutionSystemActionSubjectToJSON(value['executionSystemActionSubject']),
        'PresetSystemActionSubject': PresetSystemActionSubjectToJSON(value['presetSystemActionSubject']),
        'ExecutionSystemActionType': ExecutionSystemActionTypeToJSON(value['executionSystemActionType']),
        'CrudSystemActionType': CrudSystemActionTypeToJSON(value['crudSystemActionType']),
        'PresetSystemActionType': PresetSystemActionTypeToJSON(value['presetSystemActionType']),
    };
}

